module.exports = __webpack_public_path__ + "static/img/appriana_fortress_512px.262fadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appriana_fortress_512px.png
// module id = HVD3
// module chunks = 1